module.exports = "/_next/static/images/phone_footer-00651aa9cf56a2113e9ed920f9fddb7d.svg";